export class WebhookV1BackupPolicyNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceNames",
            "baseName": "resourceNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1BackupPolicyNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
